const OVERFLOW_MAP = {
  vertical:   "overflow-y-auto overflow-x-hidden",
  horizontal: "overflow-x-auto overflow-y-hidden",
  both:       "overflow-auto",
};

export default function ScrollArea({ children, direction = "vertical", className = "", style, as: Tag = "div" }) {
  return (
    <Tag className={`${OVERFLOW_MAP[direction]} ${className}`} style={style}>
      {children}
    </Tag>
  );
}